import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SUBSCRIPTION_CANCEL_FLOW_SURVEY_API } from '../../constants/central-api';

interface SubmitCancelFlowSurveyPayload {
  subscription_id: number | string;
  feedback?: string;
  survey_type?: string;
  satisfaction_rating?: number;
}

interface SubmitCancelFlowSurveyResponse {
  success?: boolean;
  message?: string;
  data?: any;
}

export default async function submit_cancel_flow_survey_api_call({
  subscription_id,
  feedback,
  survey_type = 'cancel_flow',
  satisfaction_rating,
}: SubmitCancelFlowSurveyPayload): Promise<SubmitCancelFlowSurveyResponse | null> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: SUBSCRIPTION_CANCEL_FLOW_SURVEY_API,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
    body: JSON.stringify({
      subscription_id,
      feedback,
      survey_type,
      satisfaction_rating,
    }),
  };

  const actionType = 'SUBMIT_SUBSCRIPTION_CANCEL_FLOW_SURVEY';
  const customMsg = 'Cancel flow survey submitted successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data as SubmitCancelFlowSurveyResponse | undefined;

  if (res?.actionType === actionType && response?.success) {
    return response;
  }

  return null;
}
